import React from "react";

import sendToClipBoard from "../../../services/sendToClipboard";

const RTMPData = ({
    primary_server,
    host_port,
    stream_name,
    encoder_rtmp,
    username,
    password
})=>{
    return (
        <React.Fragment>
            <div className={"row-eq-height" + (encoder_rtmp ? " col-sm-8" : " col-sm-12")}>
                <div className="card card-body card-dashboard-twentyone ht-xl-100p">
                    <h6 className="card-title tx-14 mg-b-10">Datos conexión software de transisión (Enconder)</h6>
                    <p className="mg-b-5">Estos datos son muy importantes para la persona que está manejando los equipos de conexión.</p>
                    <p className="mg-b-15">Copia y pega estos datos o enviarlos al personal a cargo de hacer el Streaming o Producción.</p>

                    <div className="table-responsive">
                        <table className="table table-hover mg-b-0">
                            <tbody>
                                <tr>
                                    <td>Ruta RTMP:</td>
                                    <td>{primary_server}</td>
                                    <td><button className="btn btn-outline-primary" onClick={() => {
                                        sendToClipBoard(primary_server, "La ruta ha sido copiada");
                                    }}><i className="fas fa-copy"></i> Copiar</button></td>
                                </tr>
                                <tr>
                                    <td>Puerto:</td>
                                    <td>{host_port}</td>
                                    <td><button className="btn btn-outline-primary" onClick={() => {
                                        sendToClipBoard(host_port, "El puerto ha sido copiado");
                                    }}><i className="fas fa-copy"></i></button></td>
                                </tr>
                                <tr>
                                    <td>Secuencia/Stream:</td>
                                    <td>{stream_name}</td>
                                    <td><button className="btn btn-outline-primary" onClick={() => {
                                        sendToClipBoard(stream_name, "El Nombre del Stream ha sido copiado");
                                    }}><i className="fas fa-copy"></i></button></td>
                                </tr>
                                <tr>
                                    <td>Usuario:</td>
                                    <td>{username}</td>
                                    <td><button className="btn btn-outline-primary" onClick={() => {
                                        sendToClipBoard(username, "El Usuario ha sido copiado");
                                    }}><i className="fas fa-copy"></i></button></td>
                                </tr>
                                <tr>
                                    <td>Contraseña:</td>
                                    <td>{password}</td>
                                    <td><button className="btn btn-outline-primary" onClick={() => {
                                        sendToClipBoard(password, "La contraseña ha sido copiada");
                                    }}><i className="fas fa-copy"></i></button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {(encoder_rtmp && (
                <div className="row-eq-height col-sm-4">
                    <div className="card card-body card-dashboard-twentyone ht-xl-100p">
                        <h6 className="card-title tx-14 mg-b-10">Como configurar tu encoder</h6>

                        <iframe title={"Como configurar tu encoder"} width="100%" height="350" src={"https://www.youtube.com/embed/" + encoder_rtmp} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                </div>
            ))}
        </React.Fragment>
    )
}

export default RTMPData;